import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';
import { PriceDropAlerts } from 'site-modules/shared/components/profile/price-drop-alerts/price-drop-alerts';
import edmundsLogo from 'client/images/logo-white.svg';
import edmundsLogo226 from 'client/images/edmunds-logo-226.png';
import edmundsLogoBlueWhite from 'client/images/logo-blue-white.svg';
import edmundsLogoGray from 'client/images/logo-gray.svg';

function renderLogoImg(useLogo226) {
  return (
    <img
      src={useLogo226 ? edmundsLogo226 : edmundsLogo}
      alt="Edmunds Homepage"
      width={useLogo226 ? 157 : null}
      height={useLogo226 ? 25 : null}
    />
  );
}

const LOGO_BLUE_WHITE = <img src={edmundsLogoBlueWhite} alt="Edmunds Homepage" width={157} height={25} />;
const LOGO_GRAY = <img src={edmundsLogoGray} alt="Edmunds Homepage" width={157} height={25} />;

function getLogoElement({ useGlassTheme, use2027Theme, renderLogo, useLogo226, isOpen, smallScreen }) {
  if (useGlassTheme) return LOGO_BLUE_WHITE;
  if (use2027Theme) return LOGO_GRAY;
  if (!smallScreen) return renderLogo(useLogo226);
  return renderLogo(false, isOpen);
}

export function LogoSection({
  smallScreen = false,
  toggleNav = null,
  isOpen = false,
  className = '',
  hideAlerts = false,
  useLogo226 = false,
  renderLogo = renderLogoImg,
  useGlassTheme = false,
  use2027Theme = false,
}) {
  if (!smallScreen) {
    return (
      <Link to="/" className="logo-section py-1" data-tracking-id="global_nav_homepage_click">
        {getLogoElement({ useGlassTheme, use2027Theme, renderLogo, useLogo226, isOpen, smallScreen })}
      </Link>
    );
  }

  return (
    <button className={classnames('logo-section menu-btn py-1 text-start pos-r', className)} onClick={toggleNav}>
      {getLogoElement({ useGlassTheme, use2027Theme, renderLogo, useLogo226, isOpen, smallScreen })}
      <span
        className={classnames(
          'ms-0_5 align-middle text-white text-nowrap',
          isOpen ? 'icon-arrow-up3' : 'icon-arrow-down3'
        )}
      />
      {!hideAlerts && <PriceDropAlerts hideAlertsPerSession={isOpen} />}
    </button>
  );
}

LogoSection.propTypes = {
  smallScreen: PropTypes.bool,
  toggleNav: PropTypes.func,
  isOpen: PropTypes.bool,
  hideAlerts: PropTypes.bool,
  className: PropTypes.string,
  useLogo226: PropTypes.bool,
  renderLogo: PropTypes.func,
  useGlassTheme: PropTypes.bool,
  use2027Theme: PropTypes.bool,
};
